__turbopack_context__.v({
  "benefit": "choose-your-plan-original-module__JaQPcW__benefit",
  "benefitTitle": "choose-your-plan-original-module__JaQPcW__benefitTitle",
  "benefits": "choose-your-plan-original-module__JaQPcW__benefits",
  "benefitsSubtitle": "choose-your-plan-original-module__JaQPcW__benefitsSubtitle",
  "benefitsTitle": "choose-your-plan-original-module__JaQPcW__benefitsTitle",
  "buttonWrapper": "choose-your-plan-original-module__JaQPcW__buttonWrapper",
  "carousel": "choose-your-plan-original-module__JaQPcW__carousel",
  "exclusiveBenefits": "choose-your-plan-original-module__JaQPcW__exclusiveBenefits",
  "faqTitle": "choose-your-plan-original-module__JaQPcW__faqTitle",
  "header": "choose-your-plan-original-module__JaQPcW__header",
  "howItWorks": "choose-your-plan-original-module__JaQPcW__howItWorks",
  "howItWorksStep": "choose-your-plan-original-module__JaQPcW__howItWorksStep",
  "planBonusOffer": "choose-your-plan-original-module__JaQPcW__planBonusOffer",
  "planBreaker": "choose-your-plan-original-module__JaQPcW__planBreaker",
  "planChoice": "choose-your-plan-original-module__JaQPcW__planChoice",
  "planChoices": "choose-your-plan-original-module__JaQPcW__planChoices",
  "planSubtitle": "choose-your-plan-original-module__JaQPcW__planSubtitle",
  "planTextWrapper": "choose-your-plan-original-module__JaQPcW__planTextWrapper",
  "planTitle": "choose-your-plan-original-module__JaQPcW__planTitle",
  "stepSubtitle": "choose-your-plan-original-module__JaQPcW__stepSubtitle",
  "stepTitle": "choose-your-plan-original-module__JaQPcW__stepTitle",
  "subtitle": "choose-your-plan-original-module__JaQPcW__subtitle",
  "trustpilot": "choose-your-plan-original-module__JaQPcW__trustpilot",
  "winnerImage": "choose-your-plan-original-module__JaQPcW__winnerImage",
  "winnerImages": "choose-your-plan-original-module__JaQPcW__winnerImages",
});
